// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/bg_blue.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/bg_orange.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,<svg fill=%27white%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================== background of the home page for the journals ========================*/
.home-header__bjoc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.home-header__bjnano {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.bg-skin-tagline{
    background-color: #F9E8D0;
}

/* ================== search related classes ========================*/
select#searchKey {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position-x: calc(100% - 3px);
    background-position-y: 8px;
}

.search-hit {
    color: #E32346 !important;
}

/* ================== lightgallery ========================*/
.lg-outer,
.lg-thumb-outer {
    background-color: white !important;
}


.lg-outer .lg-thumb-outer {
    background-color: lightgray !important;
}

.lg-toolbar {
    background: none !important;
}

.lg-toolbar .lg-icon,
.lg-counter {
    color: black !important;
}

.lg-next,
.lg-prev {
    background-color: transparent !important;
    color: black !important;
    top: 1rem !important;
}

.lg-media-overlap .lg-sub-html {
    background-image: none !important;
}

.lg-media-overlap .lg-sub-html {
    /* background-color: #efefef !important; */
}

.lg-sub-html {
    background-color: #efefef !important;
    text-align: left !important;
    color: black !important;
}

.lg-sub-html {
    opacity: 0.8;
}
.lg-img-wrap {
    padding: 1rem !important;
}

.lg-outer .lg-thumb-item img {
    -o-object-fit: contain !important;
       object-fit: contain !important;
}

.lg-thumb .active {
    border-color: #a90707 !important;
}

.lg-thumb-item {
    background-color: white !important;
}

a.jumperLink {
    -webkit-text-decoration: none !important;
    text-decoration: none !important;
    text-decoration-line: none !important;
    color: #003f7b !important;
}

a.jumperLink:hover {
    -webkit-text-decoration: none !important;
    text-decoration: none !important;
    text-decoration-line: none !important;
}


/* ================== list definitions for static content ========================*/
.sc ol {
    font-size: .875rem !important;
    margin-left: 2rem !important;
}
.sc ol {
    list-style-type: decimal;
}

.sc ol.upper-alpha {
    list-style-type: upper-alpha !important;
    line-height: 1rem !important;
    margin-left: 2rem !important;
}

.sc ol.lower-alpha {
    list-style-type: lower-alpha !important;
    line-height: 1rem !important;
    margin-left: 1.5rem !important;
}


.sc ol.decimal li, .sc ol.lower-alpha li, .sc ol li {
    padding: 2px !important;
    line-height: 1.5rem !important;
    font-size: .875rem !important;
}

.sc ol.decimal {
    list-style-type: decimal !important;
    line-height: 1rem !important;
    margin-left: 2rem !important;
}

/* ================== Table of contents for single article ========================*/
ul.tocList {
    padding: 2px !important;
    line-height: 1.5rem !important;
    font-size: .875rem !important;
}
ul.tocList li {
    margin-left: 1rem !important;
}
ul.tocList li {
    color: #003f7b;
    font-size: 0.8125rem; /* 13px*/
}


/* ================== series display - javascript handling ========================*/
.js-series-filter-active [id^="panel-id"] {
    display: none;
}

.js-series-filter-active [id^="panel-id"].hit {
    display: block;
}

.js-series-cat-empty {
    display: none;
}
.js-series-list-expand.disabled,
.js-series-list-collapse.disabled {
    background-color: #AEAEAE !important;
    opacity: .4 !important;
    cursor: not-allowed !important;
}

.js-series-filter-active .accordion-header .labelling {
    display:none
}


/* ================== date picker ========================*/
.datepicker-header{
    height: 3rem !important;
    background-color: white !important;
}
.datepicker-header{
    border-bottom: solid lightgrey 1px;
}

.datepicker-cell.next ,
.datepicker-cell.prev {
    color: lightgrey !important;
}

.awesomplete ul {
    width: 300px !important;
}



.mission-tile p {
    font-size: 0.8125rem !important;
}

/* ================== swiper ========================*/
.swiper {
    width: 100% !important;
    height: 100% !important;
}

.swiper-pagination-bullet {
    width: 16px !important;
    height: 8px !important;
    text-align: center !important;
    color: white !important;
    opacity: 1 !important;
    background: #fff !important;
    border-radius: 0 !important;
}

.swiper-pagination-bullet-active {
    color: #fff !important;
    background: #176191 !important;
}




`, "",{"version":3,"sources":["webpack://./src/main/resources/templates/tailwindTheme/css/bs-custom.css"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F;IACI,yDAAyC;AAC7C;;AAEA;IACI,yDAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sEAAsE;AACtE;IACI,yDAAsN;IACtN,4BAA4B;IAC5B,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4DAA4D;AAC5D;;IAEI,kCAAkC;AACtC;;;AAGA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,wCAAwC;IACxC,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;AAErC;;AAHA;IAEI,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IAEpC,2BAA2B;IAC3B,uBAAuB;AAC3B;;AALA;IAEI,YAAY;AAGhB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iCAA8B;OAA9B,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAgC;IAAhC,gCAAgC;IAChC,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,wCAAgC;IAAhC,gCAAgC;IAChC,qCAAqC;AACzC;;;AAGA,mFAAmF;AACnF;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;AAJA;IACI,wBAAwB;AAG5B;;AAEA;IACI,uCAAuC;IACvC,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,4BAA4B;IAC5B,8BAA8B;AAClC;;;AAGA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA,oFAAoF;AACpF;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,4BAA4B;AAGhC;AAJA;IAEI,cAAc;IACd,oBAAoB,EAAE,QAAQ;AAClC;;;AAGA,oFAAoF;AACpF;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;;IAEI,oCAAoC;IACpC,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI;AACJ;;;AAGA,2DAA2D;AAC3D;IACI,uBAAuB;IACvB,kCAAkC;AAEtC;AAJA;IAGI,kCAAkC;AACtC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;;;AAIA;IACI,+BAA+B;AACnC;;AAEA,sDAAsD;AACtD;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC","sourcesContent":["/* ================== background of the home page for the journals ========================*/\n.home-header__bjoc {\n    background-image: url(images/bg_blue.jpg);\n}\n\n.home-header__bjnano {\n    background-image: url(images/bg_orange.jpg);\n}\n\n.bg-skin-tagline{\n    background-color: #F9E8D0;\n}\n\n/* ================== search related classes ========================*/\nselect#searchKey {\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n    background-repeat: no-repeat;\n    background-position-x: calc(100% - 3px);\n    background-position-y: 8px;\n}\n\n.search-hit {\n    color: #E32346 !important;\n}\n\n/* ================== lightgallery ========================*/\n.lg-outer,\n.lg-thumb-outer {\n    background-color: white !important;\n}\n\n\n.lg-outer .lg-thumb-outer {\n    background-color: lightgray !important;\n}\n\n.lg-toolbar {\n    background: none !important;\n}\n\n.lg-toolbar .lg-icon,\n.lg-counter {\n    color: black !important;\n}\n\n.lg-next,\n.lg-prev {\n    background-color: transparent !important;\n    color: black !important;\n    top: 1rem !important;\n}\n\n.lg-media-overlap .lg-sub-html {\n    background-image: none !important;\n    /* background-color: #efefef !important; */\n}\n\n.lg-sub-html {\n    background-color: #efefef !important;\n    opacity: 0.8;\n    text-align: left !important;\n    color: black !important;\n}\n.lg-img-wrap {\n    padding: 1rem !important;\n}\n\n.lg-outer .lg-thumb-item img {\n    object-fit: contain !important;\n}\n\n.lg-thumb .active {\n    border-color: #a90707 !important;\n}\n\n.lg-thumb-item {\n    background-color: white !important;\n}\n\na.jumperLink {\n    text-decoration: none !important;\n    text-decoration-line: none !important;\n    color: #003f7b !important;\n}\n\na.jumperLink:hover {\n    text-decoration: none !important;\n    text-decoration-line: none !important;\n}\n\n\n/* ================== list definitions for static content ========================*/\n.sc ol {\n    list-style-type: decimal;\n    font-size: .875rem !important;\n    margin-left: 2rem !important;\n}\n\n.sc ol.upper-alpha {\n    list-style-type: upper-alpha !important;\n    line-height: 1rem !important;\n    margin-left: 2rem !important;\n}\n\n.sc ol.lower-alpha {\n    list-style-type: lower-alpha !important;\n    line-height: 1rem !important;\n    margin-left: 1.5rem !important;\n}\n\n\n.sc ol.decimal li, .sc ol.lower-alpha li, .sc ol li {\n    padding: 2px !important;\n    line-height: 1.5rem !important;\n    font-size: .875rem !important;\n}\n\n.sc ol.decimal {\n    list-style-type: decimal !important;\n    line-height: 1rem !important;\n    margin-left: 2rem !important;\n}\n\n/* ================== Table of contents for single article ========================*/\nul.tocList {\n    padding: 2px !important;\n    line-height: 1.5rem !important;\n    font-size: .875rem !important;\n}\nul.tocList li {\n    margin-left: 1rem !important;\n    color: #003f7b;\n    font-size: 0.8125rem; /* 13px*/\n}\n\n\n/* ================== series display - javascript handling ========================*/\n.js-series-filter-active [id^=\"panel-id\"] {\n    display: none;\n}\n\n.js-series-filter-active [id^=\"panel-id\"].hit {\n    display: block;\n}\n\n.js-series-cat-empty {\n    display: none;\n}\n.js-series-list-expand.disabled,\n.js-series-list-collapse.disabled {\n    background-color: #AEAEAE !important;\n    opacity: .4 !important;\n    cursor: not-allowed !important;\n}\n\n.js-series-filter-active .accordion-header .labelling {\n    display:none\n}\n\n\n/* ================== date picker ========================*/\n.datepicker-header{\n    height: 3rem !important;\n    background-color: white !important;\n    border-bottom: solid lightgrey 1px;\n}\n\n.datepicker-cell.next ,\n.datepicker-cell.prev {\n    color: lightgrey !important;\n}\n\n.awesomplete ul {\n    width: 300px !important;\n}\n\n\n\n.mission-tile p {\n    font-size: 0.8125rem !important;\n}\n\n/* ================== swiper ========================*/\n.swiper {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.swiper-pagination-bullet {\n    width: 16px !important;\n    height: 8px !important;\n    text-align: center !important;\n    color: white !important;\n    opacity: 1 !important;\n    background: #fff !important;\n    border-radius: 0 !important;\n}\n\n.swiper-pagination-bullet-active {\n    color: #fff !important;\n    background: #176191 !important;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
